import { getPromise, x64hash128 } from 'fingerprintjs2'
import { getCookie } from './helpers/CookieHandler'

async function createFingerprint () {
  const components = await getPromise({
    excludes: {
      deviceMemory: true,
      pixelRatio: true,
      hardwareConcurrency: true,
      screenResolution: true,
      availableScreenResolution: true,
      cpuClass: true,
      plugins: true,
      canvas: true,
      webgl: true,
      webglVendorAndRenderer: true,
      fonts: true,
      fontsFlash: true,
      audio: true,
      enumerateDevices: true
    }
  })
  const values = components.map(({ value }) => value)
  const hash = x64hash128(values.join(''), 31)
  document.cookie = `_hash=${hash}`
}

// unblock main thread
setTimeout(createFingerprint, 1)

export const fingerprint = async () => getCookie('_hash')



// WEBPACK FOOTER //
// ./src/fingerprint.js